import { render, staticRenderFns } from "./DIRPdRes.vue?vue&type=template&id=6f8e4fef&scoped=true&"
import script from "./DIRPdRes.vue?vue&type=script&lang=js&"
export * from "./DIRPdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e4fef",
  null
  
)

export default component.exports